import { parseResponse } from "lib/fetch";
import {
    captureBookServicePaymentRequest,
    confirmBookServicePaymentRequest,
    createBookServicePaymentRequest,
    setBookServiceClientRequest,
    updateBookServiceBookSlotsRequest,
    updateBookServicePaymentRequest,
    validateBookServiceRegisterAccountRequest,
} from "lib/api/bookService";
import type { BookingInterface } from "types/booking";
import type { UserInterface } from "types/user";
import type { Payment } from "types/bookService";

export type { DataAccount, Payment } from "types/bookService";

export const bookServiceKeys = {
    all: ["book-service"] as const,
    booking: (id: string) => [...bookServiceKeys.all, "booking", id] as const,
};

export const setClient = (id: string) => parseResponse<BookingInterface>(setBookServiceClientRequest(id));

export const updateBookSlots = (id: string, data?: unknown) =>
    parseResponse<BookingInterface>(updateBookServiceBookSlotsRequest(id, data));

export const validateRegisterAccount = (data?: HashMap<unknown>) =>
    parseResponse<UserInterface>(validateBookServiceRegisterAccountRequest(data));

export const createPayment = (params: { id: string; data?: HashMap<unknown> }) =>
    parseResponse<Payment>(createBookServicePaymentRequest(params.id, params.data));

export const updatePayment = (params: { id: string; data?: HashMap<unknown> }) =>
    parseResponse<Payment>(updateBookServicePaymentRequest(params.id, params.data));

export const capturePayment = (data: HashMap<unknown>) =>
    parseResponse<unknown>(captureBookServicePaymentRequest(data));

export const createConfirmPayment = (data: HashMap<unknown>) =>
    parseResponse<unknown>(confirmBookServicePaymentRequest(data));

const bookServiceDataFetcher = {
    setClient,
    updateBookSlots,
    validateRegisterAccount,
    createPayment,
    updatePayment,
    capturePayment,
    createConfirmPayment,
};

export default bookServiceDataFetcher;
